<template>
    <v-card class="white" height="100%">
        <v-toolbar dense dark color="#ef4044" flat>
            <v-toolbar-title><v-icon>mdi-information-variant-circle-outline</v-icon> &nbsp; Información del Paquete&nbsp;&nbsp;</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <v-btn icon text @click="onClose" v-on="on">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </template>
                <span>Cerrar</span>
            </v-tooltip>
        </v-toolbar>
        <v-card-title class="uia-red">{{ package.nombre }}
            <!-- <v-spacer></v-spacer>
            <v-tooltip left>
                <template v-slot:activator="{ on }">
                    <v-btn icon @click="onSelectPackage(package.seleccionado)" v-on="on">
                        <v-icon color="orange darken-2" v-if="package.seleccionado">
                            mdi-check-decagram
                        </v-icon>
                        <v-icon dark v-else>
                            mdi-check-decagram-outline
                        </v-icon>
                    </v-btn>
                </template>
                <span v-if="package.seleccionado">Quitar paquete</span>
                <span v-else>Seleccionar paquete</span>
            </v-tooltip> -->
        </v-card-title>
        <v-card-subtitle>{{ package.departamento }}</v-card-subtitle>
        <v-card-text>
            <v-row>
                <v-col cols="12" md="6">
                    <v-img
                        class="align-start"
                        height="250px"
                        :src=package.logoFileURL
                        gradient="to bottom, rgba(0,0,0,0.6), rgba(0,0,0,0.2)"
                    >
                    </v-img>
                </v-col>
                <v-col cols="12" md="6">
                    <div class="text-subtitle-1">
                        {{ package.descripcion }}
                    </div>
                </v-col>
            </v-row>
        </v-card-text>
        <v-divider class="mx-4"></v-divider>
        <v-card-title class="uia-red">Materias</v-card-title>
        <v-card-text>            
            <v-row v-for="(materia, i) in materiasPaqueteAlumno">
                <v-col cols="12">
                    <v-card color="grey lighten-4">
                        <v-card-title>{{ materia.clave }} - {{ materia.materia }}
                            <!-- <v-spacer></v-spacer>
                            <v-tooltip left>
                                <template v-slot:activator="{ on }">
                                    <v-btn icon @click="onSelectCourse(materia.materiaid, materia.seleccionada)" v-on="on">
                                        <v-icon color="orange darken-2" v-if="materia.seleccionada">
                                            mdi-check-decagram
                                        </v-icon>
                                        <v-icon dark v-else>
                                            mdi-check-decagram-outline
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span v-if="materia.seleccionada">Quitar materia</span>
                                <span v-else>Seleccionar materia</span>
                            </v-tooltip> -->
                        </v-card-title>
                        <v-card-text>
                            <v-divider color="#ef4044"></v-divider>
                            <p></p>
                            <v-row>
                                <v-col cols="12" md="6">
                                    {{ materia.descripcion }}
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-card>
                                        <v-toolbar height="20" dark flat color="#ef4044">
                                            <v-toolbar-title class="my-list-subtitle">Prerrequisitos</v-toolbar-title>
                                        </v-toolbar>
                                        <v-list
                                            subheader
                                            dense
                                            :height="prerreqListHeight"
                                            max-height="100%"
                                            class="overflow-y-auto"
                                            color="grey lighten-3"
                                        >
                                            <v-list-item
                                                class="my-list-item"
                                                v-for="(prerreq, j) in materia.prerrequisitos"
                                                :key="j"
                                            >
                                                <v-list-item-content>
                                                    <v-list-item-title>
                                                        {{ prerreq.clave }} - {{ prerreq.materia }}
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list>
                                    </v-card>
                                </v-col>
                            </v-row>                                
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>
                <v-btn
                    color="teal darken-3"
                    class="text-none"
                    text
                    @click="onClose"
                >OK</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'package_info',
    data() {
        return {
            selectedCourses: [],
            courseHeader: [
                {
                    text: 'Clave',
                    value: 'clave',
                    sortable: true,
                    width: '10%',
                    align: 'left',
                    divider: true,
                },
                {
                    text: 'Asignatura',
                    value: 'materia',
                    sortable: true,
                    width: '20%',
                    align: 'left',
                    divider: true,
                },
                {
                    text: 'Descripción',
                    value: 'descripcion',
                    sortable: false,
                    width: '40%',
                    align: 'left',
                    divider: true,
                }
                // {
                //     text: 'Prerrequisitos',
                //     value: 'prerrequisitos',
                //     sortable: true,
                //     width: '20%',
                //     align: 'left',
                //     divider: true,
                // },
            ],
        };
    },

    created() {
        //console.log("package = ", this.package);
        this.$store.dispatch('getMateriasPaqueteAlumno', this.package.paqueteid);
    },

    props: {
        package: Object
    },
    
    methods: {
        onClose() {
            this.showPackageInfoDlg = false;
            //console.log("materias = ", this.materiasPaqueteAlumno);
        },

        onSelectPackage(bSelected)
        {
            //Si el paquete estaba seleccionado se desselecciona:
            if (bSelected)
            {
                this.package.seleccionado = false;

                //Creo que el siguiente for no es necesario porque esto se hace en el servidor:
                for (let i = 0; i < this.userAOCs.paquetes.length; i ++)
                {
                    if (this.userAOCs.paquetes[i].paqueteid === this.package.paqueteid)
                    {
                        this.userAOCs.paquetes.splice(i, 1);
                        break;
                    }
                }

                //Se quitan las materias del paquete:

                for (let i = 0; i < this.materiasPaqueteAlumno.length; i ++)
                {
                    this.materiasPaqueteAlumno[i].seleccionada = false;

                    //Lo siguiente no es necesario porque esto se actualiza en el servidor,
                    //y no se vuelve a acceder a userAOCS.materias hasta que se vuelve a pedir
                    //al servidor después de eliminar el paquete:
                    /*for (let j = 0; j < this.userAOCs.materias.length; j ++)
                    {
                        if (this.userAOCs.materias[j].materiaid === this.materiasPaqueteAlumno[i].materiaid)
                        {
                            this.userAOCs.materias.splice(i, 1);
                            break;
                        }
                    }*/
                }

                //El paquete se pone como no seleccionado en el catálogo de paquetes:

                var bPaqueteEncontrado = false;
                for (let i = 0; i < this.catalogoAOCs.length; i ++)
                {
                    for (let j = 0; j < this.catalogoAOCs[i].departamentos.length; j ++)
                    {
                        for (let k = 0; k < this.catalogoAOCs[i].departamentos[j].paquetes.length; k ++)
                        {
                            if (this.catalogoAOCs[i].departamentos[j].paquetes[k].paqueteid === this.package.paqueteid)
                            {
                                this.catalogoAOCs[i].departamentos[j].paquetes[k].seleccionado = false;
                                bPaqueteEncontrado = true;
                                break;
                            }
                        }
                        if (bPaqueteEncontrado)
                        {
                            break;
                        }
                    }
                    if (bPaqueteEncontrado)
                    {
                        break;
                    }
                }

                //console.log("userAOCS = ", this.userAOCs);

                //Se elimina el paquete de la BD:
                this.$store.dispatch('unselectPackage', this.package.paqueteid);
            }
            else //Se selecciona el paquete:
            {
                this.package.seleccionado = true;

                //Creo que el siguiente push no es necesario porque esto se hace en el servidor:
                const newPackage = {
                    paqueteid: this.package.paqueteid,
                }
                this.userAOCs.paquetes.push(newPackage);

                //Se seleccionan las materias del paquete:
                for (let i = 0; i < this.materiasPaqueteAlumno.length; i ++)
                {
                    this.materiasPaqueteAlumno[i].seleccionada = true;
                }

                this.$store.dispatch('selectPackage', this.package.paqueteid);
            }
        },
        

        onSelectCourse(courseID, selected)
        {},
    },

    computed:
    {
        ...mapGetters([
            'waitCursor',
        ]),

        showPackageInfoDlg: {
            get() {
                return this.$store.getters.showPackageInfoDlg;
            },
            set(showPackageInfoDlg) {
                this.$store.dispatch('updateShowPackageInfoDlg', showPackageInfoDlg);
            },
        },

        prerreqListHeight() {
            var height;
            if (this.$vuetify.breakpoint.xs) {
                height = '60px';
            } else if (this.$vuetify.breakpoint.sm) {
                height = '100px';
            } else {
                height = '80px';
            }
            return height;
        },

        catalogoAOCs: {
            get() {
                return this.$store.getters.catalogoAOCs;
            },
            set(catalogoAOCs) {
                this.$store.dispatch('updateCatalogoAOCs', catalogoAOCs)
            },
        },

        userAOCs: {
            get() {
                return this.$store.getters.userAOCs;
            },
            set(userAOCs) {
                this.$store.dispatch('updateUserAOCs', userAOCs)
            },
        },

        materiasPaqueteAlumno: {
            get() {
                return this.$store.getters.materiasPaqueteAlumno;
            },
            set(materiasPaqueteAlumno) {
                this.$store.dispatch('updateMateriasPaqueteAlumno', materiasPaqueteAlumno)
            },
        },
    }
};
</script>

<style scoped>

.uia-red {
    color:#ef4044!important;
}
.my-list-title {
    font-size: 15px;
    font-weight: bold;
}
.my-list-subtitle {
    font-size: 13px;
    font-weight: bold;
}

.my-list-item {
    min-height: 30px !important;
}

/* ***************Modificaciones para que no se parta el texto en v-card-text y en v-card-title (al parecer es un bug de vuetify):************* */
.v-card__text,
.v-card__title {
    word-break: normal; /* maybe !important  */
}

.my_pointer {
    cursor: pointer;
}

a:link,
a:visited {
    color: #c62828;
    text-decoration: none;
}

a:link:active,
a:visited:active {
    color: #c62828;
}

</style>